var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":`I have a valid driver's license`,"color":_vm.themes.candidate.light.input},on:{"change":_vm.submit},model:{value:(_vm.profile.driversLicense),callback:function ($$v) {_vm.$set(_vm.profile, "driversLicense", $$v)},expression:"profile.driversLicense"}})
}
var staticRenderFns = []

export { render, staticRenderFns }